module.exports = __webpack_public_path__ + "img/icon-review@2x.8041762f.png";